import React, { useRef, useEffect, useState } from "react";

import { Link } from 'react-router-dom';
import AuthService from "../../services/auth.service";
import { useNavigate } from "react-router-dom";
import { useHistory } from 'react-router-dom';



import { Outlet } from "react-router-dom";
import logo from "../../assets/img/logo.jpg";
import Sidebar1 from "./Sidebar1";
import Navbar1 from "./Navbar1";

//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";


// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
 //---------------- CONTEXT API ------------------
    const store = useStore();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [menuSideShow, setMenuSideToogle] = useState(false);
    
  
    //---mostrar y ocultar sideshow
    const menuSideToogle_click=()=>{ 
      console.log("menuSideToogle_click");
      //-- 1ra modif
      //html className="menu-opened"
      const elem1 = document.querySelector("body");
      elem1.classList.toggle("mini-sidebar");


      if(menuSideShow){
          //-- esta en true
          console.log("true");
          setMenuSideToogle(false);  
      }else{
          console.log("false");
          setMenuSideToogle(true);  
      }

    }
    //-----------------------------------
   /* const menuSideToogleMovil_click=()=>{ 

      //-- 1ra modif
      //html className="menu-opened"
      const elem = document.querySelector("div.main-wrapper");
      elem.classList.toggle("slide-nav");
      //------2da modifi
      const elem2 = document.querySelector("div.sidebar");
      elem2.classList.toggle("opened");
      
      //------3da modifi
      const elem1 = document.querySelector("body");
      elem1.classList.toggle("menu-opened");

      const elem3 = document.querySelector("div.sidebar-overlay");
      elem3.classList.toggle("opened");
      

      if(menuSideShow){
          //-- esta en true
          console.log("true");
          setMenuSideToogle(false);  
      }else{
          console.log("false");
          setMenuSideToogle(true);  
      }

  }*/
  //-----------------------
  const menuOpt_click=()=>{
    //---- hacemos auto click
    menuSideToogle_click()
  }
  //-----------------------------------
  const logout=(e)=>{
      e.preventDefault();
      //console.log("aqui estoy");
      AuthService.logout();
      navigate("/login");
      //let history = useHistory();
      //history.push("/login");
  }
  //---------- NUEVO ------------------
  const miClase = menuSideShow? 'active':'';
  //-----------------------------------------------------------
  return (
      <div>
        
        {/*------- */}
        <div className="wrapper1">
          {/* sidebar */}
          <Sidebar1 onShow={menuSideShow}
                    btnOptClick={ menuOpt_click }/>
          {/* Page Content  */}
          <div id="content" className={miClase} style={{ backgroundColor: '#f3f3f3'}}>
            <Navbar1 btnMenuClick={ menuSideToogle_click } />
            {/* Contenido */}
            <div className={` container `}>
                  <Outlet />
            </div>
          </div>
          
        </div>
      

      </div>
    )
}